module.exports = __webpack_public_path__ + "media/images/campaign-c4bceaf7cd584c52cb73ef29c1a69e93.png";